<template>
  <div class="app-container">
    <el-dialog
      :width="handleCommon('dialog.medium')"
      title="修改"
      :close-on-click-modal="false"
      :visible.sync="dataDialogVisible"
      :close="handleCancel">
      <el-form
        :ref="form"
        label-width="110px"
        :model="handleStateGetter('editData')">
        <el-form-item
          :label="handleCommon('label.content')"
          prop="remark"
          :rules="remarkRule">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            maxlength="200"
            show-word-limit
            v-model="remark">
          </el-input>
        </el-form-item>
        <el-form-item
          :label="handleCommon('label.status')"
          prop="status"
          :rules="statusRule">
          <el-radio-group v-model="status">
            <el-radio
              v-for="item in getStatusList"
              :key="item.value"
              :label="item.value"
              :value="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          :loading="saveDisable"
          type="primary"
          @click="handleSaveData">
          {{ handleCommon('setting.saveBtn') }}
        </el-button>
        <el-button
          @click="handleCancel">
          {{ handleCommon('setting.cancelBtn') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/utils/common'

export default {
  data() {
    return {
      moduleName: 'contact',
      saveDisable: false,
      form: 'form',
      remarkRule: [{ required: true, message: this.handleCommon('setting.request') }],
      statusRule: [{ required: true, message: this.handleCommon('setting.request') }]
    }
  },
  computed: {
    getStatusList() {
      let arr = this.$store.getters[`${this.moduleName}/getStatusList`]
      let newArr = []
      arr.forEach(key => {
        if (key.value) {
          newArr.push(key)
        }
      })
      return newArr
    },
    dataDialogVisible: {
      get() {
        return this.handleStateGetter('dataDialogVisible')
      },
      set(val) {
        this.handleStateSetter(`${this.moduleName}/UPDATE_STATE`, 'dataDialogVisible', val)
      }
    },
    remark: {
      get () {
        return this.handleStateGetter('editData.remark')
      },
      set (val) {
        this.handleStateSetter(`${this.moduleName}/SET_EDIT`, 'remark', val)
      }
    },
    status: {
      get() {
        return this.handleStateGetter('editData.status')
      },
      set (val) {
        this.handleStateSetter(`${this.moduleName}/SET_EDIT`, 'status', val)
      }
    }
  },
  methods: {
    handleCommon(k) {
      return k.split('.').reduce((a, c) => a[c], common)
    },
    handleSaveData() {
      this.$refs[this.form].validate(valid => {
        if (valid) {
          this.saveData()
        }
      })
    },
    saveData() {
      this.saveDisable = true
      this.$message(common.message.saving)
      this.$store.dispatch(`${this.moduleName}/Edit`).then(res => {
        this.$message.success(common.message.saveSuccess)
        this.$store.dispatch(`${this.moduleName}/GetList`)
        this.handleCancel()
      }).catch(err => {
        this.saveDisable = false
        this.$message.error(err.response.data.message)
      })
    },
    handleCancel() {
      this.saveDisable = false
      this.$refs[this.form].resetFields()
      this.$store.commit(`${this.moduleName}/SET_EDIT_DEFAULT`)
      this.handleStateSetter(`${this.moduleName}/UPDATE_STATE`, 'dataDialogVisible', false)
    },
    handleStateSetter(m, k, v) {
      this.$store.commit(m, { key: k, val: v })
    },
    handleStateGetter(k) {
        return eval(`this.$store.state.${this.moduleName}.${k}`)
    }
  }
}
</script>
